import axios from "axios";
export default {
    state: () => ({
        warenkorbPositionen: [],
        anzWarenkorbPositionen: 0
    }),
    getters: {
        getWarenkorbPos(state) {
            return state.warenkorbPositionen;
        },
        getAnzWarenkorbPositionen: (state) => state.warenkorbPositionen.length
    },
    mutations: {
        SET_WARENKORBPOSITIONEN: (state, positionen) => state.warenkorbPositionen = positionen,
        SET_ANZ_WARENKORBPOSITIONEN: (state, anz) => state.anzWarenkorbPositionen = anz
    },
    actions: {
        loadWarenkorbUebersicht(context, data) {
            const lang = (data === null || data === void 0 ? void 0 : data.land) || "de";
            const land = (data === null || data === void 0 ? void 0 : data.lang) || "de";
            const shop = (data === null || data === void 0 ? void 0 : data.shop) || "";
            let url = "/konfigurator_php/global/wkmenuContentLoader.php" + "?lang=" + lang + "&land=" + land;
            if (shop !== "") {
                url = url + "&shop=" + shop;
            }
            axios({
                url: url,
            }).then(response => context.commit("SET_WARENKORBPOSITIONEN", response.data));
        }
    },
};
//# sourceMappingURL=WarenkorbZusammenfassung.js.map